import { createFileRoute } from '@tanstack/react-router'
import IntegrationArInvoiceReconciliation from '../components/integration-reconciliation/IntegrationArInvoiceReconciliation'

export const Route = createFileRoute('/_a/integrations/$integrationId/reconciliation')({
  component: IntegrationArInvoiceReconciliation,
})
